import React from 'react';
import '../styles/Endorsements.scss';

const NPCI = `${process.env.REACT_APP_S3_URL}NPCI.svg`;
const BharatPay = `${process.env.REACT_APP_S3_URL}BharatBillPayEmblem.svg`; // Space encoded as %20
const steps = `${process.env.REACT_APP_S3_URL}steps.svg`;
const stepsMobile = `${process.env.REACT_APP_S3_URL}stepsMobile.svg`;
const endorsements = [
    { id: 1, name: 'NPCI \n Preferred Partner', logo: NPCI, image: NPCI },
    { id: 2, name: 'NBBL \n empaneled TSP', logo: BharatPay, image: BharatPay }
];

const Endorsements: React.FC = () => {

    return (
        <section className="endorsements-section">
            <h2>Our <strong
            style={{
                background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text', // For Firefox
                color: 'transparent',
              }}
            >
                    Endorsements
                </strong>
            </h2>
            <div className="endorsement-logos">
                {endorsements.map(endorsement => (
                    <div key={endorsement.id} className="endorsement-card">
                        <div className='combine-logo'>
                            <img className='cl-img' src={endorsement.logo} alt={endorsement.name} />
                            {/* <div className='combine-logo-center'>
                                <img src={endorsement.image} alt={endorsement.name} />
                            </div> */}
                        </div>
                        <p>{endorsement.name}</p>
                    </div>
                ))}
            </div>
            <div className='steps' style={{ marginBottom:'-4px'}}>
                <img src={steps} alt='' />
            </div>
            <div className='stepsMobile'>
                <img style={{ width:'100%', marginBottom:'-4px' }} src={stepsMobile} alt='' />
            </div>
        </section>
    );
};

export default Endorsements;
